'use strict';

app.controller('SharesCtrl', [
    '$scope',
    '$http',
    '$translate',
    '$state',
    'toaster',
    function($scope, $http, $translate, $state, toaster) {
        $scope.loading = false;
        $scope.shared = {};

        $scope.form = {
            link: '',
        };
        $scope.initialForm = angular.copy($scope.form);

        $scope.resetForm = function() {
            $scope.form = angular.copy($scope.initialForm);
        };

        $scope.afterFormAction = function() {
            $state.go($state.current, {}, { reload: true });
        };

        $scope.unshare = function(id) {
            $http.post('/api/group/unshare', { id: id }).then(function() {
                $scope.afterFormAction();
            });
        };
        $scope.share = function() {
            var payload = $scope.form;

            if (!payload.link) {
                toaster.pop(
                    'error',
                    $translate.instant('general.toastr.error.header'),
                    $translate.instant(
                        'general.toastr.error.form.validation.fill'
                    )
                );
                return false;
            }

            $http.post('/api/group/share', payload).then(
                function() {
                    $scope.afterFormAction();
                },
                function(error) {
                    toaster.pop(
                        'error',
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant(
                            'shares.toastr.error.form.' + error.data.message
                        )
                    );
                }
            );
        };
        $scope.get = function() {
            $scope.loading = true;
            $http.get('/api/group/shares').then(
                function(response) {
                    $scope.shared = response.data.data.groups;
                    $scope.loading = false;
                },
                function() {
                    $scope.loading = false;
                }
            );
        };
        $scope.init = function() {
            $scope.get();
        };
        $scope.init();
    },
]);
